import { arabicPlural } from '../../utils/alertDisplay';

/** `{name}` placeholders, the same way the locale files write them. */
export const fill = (template, values) =>
  Object.entries(values).reduce((text, [name, value]) => text.replace(`{${name}}`, value), template);

/** The noun for a count: Arabic has its own rule, English is one or many. forms = { one, two, few }. */
export const nounFor = (count, forms, language) => (
  language === 'ar'
    ? arabicPlural(count, forms.one, forms.two, forms.few)
    : (count === 1 ? forms.one : forms.few)
);
